import Spline from '@splinetool/react-spline';
import React from 'react'

const Mushroom = () => {
  return (
    <Spline scene="https://prod.spline.design/MM78IU2mpYfy7oVD/scene.splinecode" />
  )
}

export default Mushroom